export function paymentTaxDue(d: any, notes: any[]) {
 if (!d) return null;
 const note=notes.filter(n=>n.declaration_id===d.id).sort((a,b)=>String(b.created_at||'').localeCompare(String(a.created_at||'')))[0];
 const rate=Number(note?.exchange_rate ?? d.exchange_rate);
 let usd: number;
 if(note) usd=Number(note.amount_due_usd);
 else {
  const native=d.declared_usd!=null||d.declared_cdf!=null||d.collected_usd!=null||d.collected_cdf!=null;
  const cdf=Number(d.declared_cdf??d.collected_cdf??0);
  if(cdf>0&&(!Number.isFinite(rate)||rate<=0)) return null;
  const turnover=native?Number(d.declared_usd??d.collected_usd??0)+(cdf===0?0:cdf/rate):Number(d.declared_amount??d.system_amount??0);
  const taxRate=Number(d.fpt_rate??0.04);
  if(!Number.isFinite(turnover)||turnover<0||!Number.isFinite(taxRate)||taxRate<0) return null;
  usd=Math.round(turnover*taxRate*100)/100;
 }
 if(!Number.isFinite(usd)||usd<0) return null;
 return {usd,cdf:Number.isFinite(rate)&&rate>0?Math.round(usd*rate):0};
}
